<template>
  <div>
    <VHeader class="tabBar" />
    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import VHeader from "@/components/header/index.vue";
import utils from "@/utils";
// import { getMessageList } from "@/api";
export default {
  data () {
    return {};
  },
  methods: {
    async initMessage () {
      try {
        let data = {
          pageNum: 1,
          pageSize: 5,
        };
        let res = await getMessageList(data);
        if (res.success) {
          this.list_data = res.result.data.records;
          //设置导航的消息未读状态
          let isRead = res.result.unReadNumber;
          this.$store.dispatch("setMsgRead", isRead);
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted () {
    // this.initMessage();
  },
  components: {
    VHeader,
  },
};
</script>

<style lang="scss" scoped>
.layout {
  height: 100%;
  display: flex;
  flex-direction: column;
  .tabBar {
    flex-shrink: 0;
  }
  .layout_item {
    flex-grow: 1;
    background: #f3f3f3;
    // display:flex;
    // flex:1;
  }
}
</style>
